/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const ThunderboltSvg = () => (
  <svg width="1.1em" height="1.1em" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.80884 0.946887C7.82287 0.954634 7.82979 0.971084 7.82576 0.986599L6.40674 6.44783C6.30259 6.84866 6.54325 7.25808 6.94403 7.36234L8.90622 7.87219C8.91817 7.87532 8.92767 7.88493 8.9311 7.89681C8.93437 7.90862 8.93091 7.92095 8.9225 7.92989L2.2313 15.0462C2.22041 15.0578 2.20305 15.0609 2.18907 15.0534C2.17504 15.0456 2.16812 15.0292 2.17215 15.0137L3.59116 9.55243C3.6953 9.15164 3.45457 8.74224 3.05388 8.63792L1.09169 8.12808C1.0797 8.12496 1.07025 8.11535 1.06681 8.10345C1.06354 8.09175 1.06624 8.07906 1.07446 8.07012L7.76661 0.954076C7.77754 0.942454 7.79484 0.939277 7.80884 0.946887Z" fill="white" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
  </svg>

);

export const ThunderboltIcon = (props) => <Icon component={ThunderboltSvg} {...props} />;
